import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CrueltyFreeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cruelty_free"}/>
}
